import { GripVertical, Trash2 } from 'lucide-react';
import { EventType } from '../../../types/event-types.types';

interface EventTypeItemProps {
  eventType: EventType;
  onUpdate: (id: string, updates: Partial<EventType>) => void;
  onDelete: (id: string) => void;
}

export function EventTypeItem({ eventType, onUpdate, onDelete }: EventTypeItemProps) {
  return (
    <div style={{ padding: '1rem', background: 'white', border: '2px solid #e5e7eb', borderRadius: '12px', transition: 'all 0.2s ease' }}>
      <div style={{ display: 'flex', gap: '1rem', alignItems: 'flex-start' }}>
        <div style={{ padding: '0.5rem', color: '#9ca3af', cursor: 'grab' }}>
          <GripVertical size={20} />
        </div>
        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
          <input
            type="text"
            value={eventType.label}
            onChange={(e) => onUpdate(eventType.id, { label: e.target.value })}
            placeholder="Nom du type d'événement"
            style={{ padding: '0.75rem', fontSize: '0.95rem', fontWeight: 600, border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none' }}
            onFocus={(e) => { e.currentTarget.style.borderColor = '#00758d'; }}
            onBlur={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
          />
          <input
            type="text"
            value={eventType.description}
            onChange={(e) => onUpdate(eventType.id, { description: e.target.value })}
            placeholder="Description (optionnel)"
            style={{ padding: '0.75rem', fontSize: '0.85rem', border: '1px solid #e5e7eb', borderRadius: '8px', outline: 'none' }}
            onFocus={(e) => { e.currentTarget.style.borderColor = '#00758d'; }}
            onBlur={(e) => { e.currentTarget.style.borderColor = '#e5e7eb'; }}
          />
        </div>
        <button
          onClick={() => onDelete(eventType.id)}
          style={{ padding: '0.5rem', background: '#f4d9e5', color: '#8E0B56', border: 'none', borderRadius: '8px', cursor: 'pointer', transition: 'all 0.2s ease' }}
          onMouseEnter={(e) => { e.currentTarget.style.background = '#e8bccf'; }}
          onMouseLeave={(e) => { e.currentTarget.style.background = '#f4d9e5'; }}
        >
          <Trash2 size={18} />
        </button>
      </div>
    </div>
  );
}
